import React from 'react'
import { useRouter } from 'next/router'

import { Button } from '@components/Buttons'
import { ArrowLeftIcon } from '@components/icons/ArrowLeftIcon'
import { ArrowRightIcon } from '@components/icons/ArrowRightIcon'
import { NavigateOtherStoryProps } from './interface'

function NavigateOtherStory({
  previousAndNextBookId,
}: NavigateOtherStoryProps) {
  const router = useRouter()
  return (
    <div>
      <div className='flex justify-between pt-[30px] mobile:p-[20px_10px_0] text-white'>
        <Button
          type='button'
          className='border border-secondary-1 bg-transparent dark:border-dark-10 h-[40px] mobile:w-[164px] mobile:px-[10px]'
          disabled={!previousAndNextBookId?.previousBookId}
          onClick={() =>
            router.push(`/story/${previousAndNextBookId?.previousBookId}`)
          }
        >
          <div className='flex items-center text-sm text-secondary-1 dark:text-dark-10'>
            <ArrowLeftIcon className='mr-[5px]' width='24' height='24' />
            งานเขียนก่อนหน้า
          </div>
        </Button>

        <Button
          type='button'
          className='border border-secondary-1 bg-transparent dark:border-dark-10 h-[40px] mobile:w-[164px] mobile:px-[10px]'
          disabled={!previousAndNextBookId?.nextBookId}
          onClick={() =>
            router.push(`/story/${previousAndNextBookId?.nextBookId}`)
          }
        >
          <div className='flex items-center text-sm text-secondary-1 dark:text-dark-10'>
            งานเขียนถัดไป
            <ArrowRightIcon className='ml-[5px]' width='24' height='24' />
          </div>
        </Button>
      </div>
    </div>
  )
}

export default NavigateOtherStory
